import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, Button, Table, Modal, Input, Popconfirm } from "antd";
import {
  useFetchIncidentsQuery,
  useUpdateIncidentMutation,
  useDeleteIncidentMutation,
} from "./incident.service";
import { CheckOutlined, DeleteOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import "./style.css";

const { Column } = Table;

export default function Incident() {
  const {
    t,
    i18n: { language },
  } = useTranslation();

  const navigate = useNavigate();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [resolution, setResolution] = useState("");

  const { data = [] } = useFetchIncidentsQuery();
  const [
    requestUpdateIncident,
    { isSuccess: updateSuccess, isLoading: updateLoading },
  ] = useUpdateIncidentMutation();
  const [requestDeleteIncident, { isSuccess: deleteSuccess }] =
    useDeleteIncidentMutation();

  const handleCancel = () => {
    setIsModalOpen();
    setResolution("");
  };

  const handleOk = () => {
    requestUpdateIncident({ id: isModalOpen, data: { resolution } });
  };

  const handleDelete = (id) => {
    requestDeleteIncident(id);
  };

  useEffect(() => {
    if (updateSuccess || deleteSuccess) {
      setResolution("");
      setIsModalOpen();
    }
  }, [updateSuccess, deleteSuccess]);

  return (
    <Card
      className="incident-page"
      bordered={false}
      title={`${t("Incident")} ${t("List")}`}
      extra={
        <Button type="primary" onClick={() => navigate("/incidents/create")}>
          {t("Create")}
        </Button>
      }
    >
      <div className="incident-page-container">
        <Table
          dataSource={data}
          pagination={{
            current: 1,
            pageSize: 10,
          }}
        >
          <Column
            align="center"
            title={t("INCIDENT")}
            dataIndex={`incident_${language}`}
          />
          <Column
            align="center"
            title={t("NAME OF EMPLOYEE")}
            dataIndex={"employeeName"}
          />
          <Column
            align="center"
            title={t("RESOLUTION")}
            dataIndex={`resolution_${language}`}
          />
          <Column
            title={t("TOOLS")}
            align="center"
            render={(value, record, index) => (
              <div
                style={{
                  display: "flex",
                  gap: "8px",
                  justifyContent: "center",
                }}
              >
                <CheckOutlined
                  className={
                    record[`resolution_${language}`] !== ""
                      ? "checklist-complete"
                      : "checklist-pending"
                  }
                  onClick={() => {
                    setIsModalOpen(record._id);
                    setResolution(record[`resolution_${language}`]);
                  }}
                />
                <Popconfirm
                  title={t("Delete Incident")}
                  description={t(
                    "Are you sure you want to delete this incident?"
                  )}
                  onConfirm={() => handleDelete(record._id)}
                  okText={t("Yes")}
                  cancelText={t("No")}
                >
                  <DeleteOutlined style={{ color: "red", cursor: "pointer" }} />
                </Popconfirm>
              </div>
            )}
          />
        </Table>
      </div>
      <Modal
        title={t("RESOLUTION")}
        open={isModalOpen ? true : false}
        onOk={handleOk}
        onCancel={handleCancel}
        loading={updateLoading}
      >
        <Input.TextArea
          rows={3}
          onChange={(e) => setResolution(e.target.value)}
          value={resolution}
        />
      </Modal>
    </Card>
  );
}
